import { forwardRef } from "react"
import getMessage from "../../utils/getMessage"

/**
 * Uses the solution from:
 * https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
 * @param {*} param0 
 * @returns 
 */
const DigiraatiAutoResizeTextarea = forwardRef(({
  value,
  onChange,
  autoFocus,
  className="comment-textarea",
  id,
  disabled,
  placeholder,
  maxLength,
  ariaLabelText=undefined,
}, ref) => {

  const growWrapStyle={
    display: "grid",
    maxHeight: "60vh",
    overflowY: "auto",
    position: "relative",
  }
  const commonStyle={
    
    border: "none",
    outline: "none",
    padding: "0.2rem",
    font: "inherit",
    gridArea: "1 / 1 / 2 / 2",
  }

  const resizerStyle = {
    ...commonStyle,
    visibility: "hidden",
    whiteSpace: "pre-wrap",
  }
  const textareaStyle = {
    ...commonStyle,
    resize: "none",
    overflow: "hidden",
    height: "initial",
    fontFamily: 'Quicksand',
  }
  const textAreaDescriptionStyle = {
    position: 'absolute',
    right: '1em',
    bottom: 0,
    fontFamily: 'Quicksand',
    fontSize: 'small',
    textAlign: 'right',
  }

  return (
    <div>
      <div style={growWrapStyle}>
        <div style={resizerStyle}>
          {value}&nbsp;
        </div>

        <textarea 
          style={textareaStyle} 
          id={id} ref={ref} 
          className={className} 
          disabled={disabled}
          placeholder={placeholder}
          maxLength={maxLength}
          autoFocus={autoFocus}
          value={value}
          onChange={onChange}
          aria-label={ariaLabelText ? getMessage(ariaLabelText) : undefined}
          aria-describedby={`${id}-textarea-description`}
          rows={1}
        />
      </div>
      <div id={`${id}-textarea-description`} style={textAreaDescriptionStyle}>
        {(value ?? "").length} / {maxLength}
      </div>
    </div>
  )

})

export default DigiraatiAutoResizeTextarea;